<script lang="ts">
  import { getHref } from '../../helpers/sections-helper';
  import { BulletPoint } from '../../components/index';
  import type { Video } from '../types';
  import './css/video.scss';

  export let properties: Video;

  $: ({ button, callouts, description, headline, video } = properties);

  $: videoMap = getVideoEmbed(video.value);

  const getYoutubeVideoId = (url: string) => {
    const regex =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(regex);
    if (match?.[7].length == 11) {
      return match[7];
    }
    return null;
  };

  const getVimeoVideoId = (url: string) => {
    const regex =
      /(?:http:|https:|)\/\/(?:player.|www.)?vimeo\.com\/(?:video\/|embed\/|watch\?\S*v=|v\/)?(\d*)/;
    const match = url.match(regex);
    return match?.[1] || null;
  };

  const getVideoEmbed = (url: string) => {
    const youtubeVideoId = getYoutubeVideoId(url);
    if (youtubeVideoId) {
      return {
        embed: `https://www.youtube-nocookie.com/embed/${youtubeVideoId}?autoplay=1&si=NP4UkKkrJm4mREvX&amp;controls=1`,
        type: 'youtube',
      };
    }

    const vimeoVideoId = getVimeoVideoId(url);
    if (vimeoVideoId) {
      return {
        embed: `https://player.vimeo.com/video/${vimeoVideoId}?autoplay=1`,
        type: 'vimeo',
      };
    }

    return {
      embed: url,
      type: 'other',
    };
  };
</script>

<section class="video-upload">
  <div class="wrapper">
    <div class="desktop-video">
      <div class="video-top">
        <h2 class="h2">{@html headline.value}</h2>
        <p class="sub-text">
          {@html description.value}
        </p>
      </div>
      <div class="video-box">
        {#key videoMap}
          {#if videoMap.type === 'youtube' || videoMap.type === 'vimeo'}
            <iframe
              width="640"
              height="360"
              src={videoMap.embed}
              title="Media video player"
              frameborder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            />
          {:else if videoMap.type === 'other'}
            <video controls>
              <source src={videoMap.embed} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          {/if}
        {/key}
      </div>
      {#if button?.label?.length}
        <div class="bottom-boxes">
          <a
            id="video-success-book-now"
            class="primary-button open-form-js"
            href={getHref(button.link_type, button.link)}
            >{@html button.label}
          </a>
          <div class="small-text-box">
            {#each callouts.value as item}
              <div>
                <BulletPoint bulletIcon={callouts?.icon} />
                <p class="text-small">{@html item}</p>
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</section>
